import {useEffect, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import Header from '../../components/header/Header.jsx'
import ImageProduct from './imageProduct/ImageProduct.jsx'
import InformationProduct from './informationProduct/InformationProduct.jsx'
import AddBagBuyButton from './addBagBuyButton/AddBagBuyButton.jsx'
import Variations from './variations/Variations.jsx'
import InputObservation from './inputObservation/InputObservation.jsx'
import {TourFlavorAssistant} from '../../components/tour/Tour.jsx'
import Tour from 'reactour'
import {ThemeProvider} from '@mui/material/styles'
import themeMui from '../../themeMui.jsx'
import {Snackbar} from '@mui/material'
import {checkUndefined, isEmpty} from 'react-lf-tools'
import moment from 'moment'
import {ItemBagContext} from '../../context/ItemBagContext.jsx'
import {itemBag as textsItemBag, itemBag as textsItemsBag} from '../../translate/Translate.jsx'
import {getLocal, getSession, setLocal, setSession} from '../../hooks/useStorage/useStorage.jsx'
import {
    colors,
    findVariationByName,
    trackEventAnalytics,
    log,
    trackEventPixel,
    smoothScrolling,
    trackPageView,
    formatItemsAnalytics,
    roundValues
} from '../../utils/utils.jsx'
import {motion} from 'framer-motion'
import FloatingButton from './floatingButton/FloatingButton.jsx'
import {DialogFlavor, DialogQuantity} from '../../components/dialogs/Dialogs.jsx'

import './itemBag.scss'

const steps_tour = [
    {
        selector: '.floating-button-item-bag',
        content: () => <TourFlavorAssistant/>,
        style: {
            borderRadius: 20
        }
    }
]

const ItemBag = () => {
    const locantion = useLocation()
    const navigate = useNavigate()
    const product = locantion.state.product
    const isEditing = locantion.state.edit
    const itemEditing = locantion.state.item
    const isCouponProduct = locantion.state.isCouponProduct
    const redeemCoupon = locantion.state.redeemCoupon || false
    const couponData = locantion.state.couponData || {}
    const linkRedirection = locantion.state.linkRedirection || false
    const [canOrder] = useState(product?.canOrder ?? true)
    const [prevScrollpos, setPrevScrollpos] = useState(window.pageYOffset)
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: ''
    })
    const [variations, setVariations] = useState([])
    const [observations, setObservations] = useState([])
    const [additional, setAdditional] = useState({})
    const [optional, setOptional] = useState({})
    const [additionalTotal, setAdditionalTotal] = useState(0)
    const [productQuantity, setProductQuantity] = useState(1)
    const [quantityFractioned, setQuantityFractioned] = useState('1')
    const [total, setTotal] = useState(product.price)
    const [isAddItem, setAddItem] = useState('')
    const [isVisibleObs, setVisibleObs] = useState(true)
    const [observationItem, setObservationItem] = useState('')
    const [item, setItem] = useState('')
    const [isEdit, setEdit] = useState(false)
    const [flavorItems, setFlavorItems] = useState([])
    const [modeFlavor, setModeFlavor] = useState(false)
    const [dialogFlavor, setDialogFlavor] = useState({
        open: false
    })
    const [dialogQuantity, setDialogQuantity] = useState({
        open: false
    })
    const [tour, setTour] = useState({
        open: false,
        step: 0
    })
    const [itemDelete, setItemDelete] = useState({})

    const handleCloseDialogQuantity = () => setDialogQuantity({open: false})

    const handleClickDialogFlavor = (item) => {
        setItemDelete(item)
        if (additional[item.stepIndex].length === 1) setDialogFlavor({open: false})
    }

    const handleCloseDialogFlavor = () => setDialogFlavor({
        open: false
    })

    const handleCloseSnackbar = () => setSnackbar({open: false})

    const handleSearch = value => {
        const s = findVariationByName(variations, value)
        if (s !== null) {
            smoothScrolling(s.option, 10, 70)
        }
    }

    const handleMessage = (message) => setSnackbar({
        open: true,
        message: message
    })

    const handleClickInfo = () => {
        setDialogQuantity({open: true})
    }

    const handleClickVariation = () => {
        const options = []
        addItemsOptions(additional, options)
        addItemsOptions(optional, options)
        addItemsOptions(observations, options)
        const dataMandatory = checkMandatory(options)
        if (!dataMandatory.response) {
            setSnackbar({
                open: true,
                message: dataMandatory.message
            })
            smoothScrolling(`step${dataMandatory.step}`, 50, 10, true)
        }
    }

    const handleNextStep = (step) => {
        try {
            const index = variations.findIndex((variation) => variation.step === step)
            if (index === -1 || index >= variations.length - 1) return
            const stepIndex = variations[index + 1].stepIndex
            smoothScrolling(`step${stepIndex}`, 50, 10, true)
        } catch (e) {
            console.error(e.message)
        }
    }

    const handleClickFloationgButton = () => {
        setDialogFlavor({open: true})
        setTour({open: false})
        setLocal('tourFlavor', 'ok')
    }

    const handleClickAdd = () => {
        if (productQuantity === 0) return setSnackbar({
            open: true,
            message: `${textsItemBag.minimumQuantity} 1`
        })
        const dataMaximumQuantity = checkMaximumQuantity()
        if (!dataMaximumQuantity.response) return setSnackbar({
            open: true,
            message: dataMaximumQuantity.message
        })
        const items = getLocal('items', [])
        const options = []

        addItemsOptions(additional, options)
        addItemsOptions(optional, options)
        addItemsOptions(observations, options)
        const dataMandatory = checkMandatory(options)
        if (!dataMandatory.response) {
            setSnackbar({
                open: true,
                message: dataMandatory.message
            })
            smoothScrolling(`step${dataMandatory.step}`, 50, 10, true)
            return
        }
        options.sort((a, b) => {
            if (a.stepIndex < b.stepIndex) return -1
            if (a.stepIndex > b.stepIndex) return 1
            return 0
        })
        const subitems = []
        options.forEach(o => subitems.push({
            sku: o.sku,
            option: o.option,
            amount: o.amount,
            priceProduct: o.price,
            price: (o.price * o.amount),
            step: o.step,
            valuePercentage: o.valuePercentage
        }))

        let s = sortItemsByStep(subitems)

        const itemToCreate = {
            id: isEditing ? item.id : moment().toDate().getTime(),
            sku: product.sku,
            image: product.image,
            product: product.product,
            amount: productQuantity,
            priceProduct: product.price,
            price: roundValues(total),
            observation: observationItem,
            subitems: s,
            datetime: moment().toDate(),
            isCouponProduct: isCouponProduct,
            fractioned: product.fractioned,
            version: import.meta.env.VITE_VERSION_NAME
        }
        if (redeemCoupon) {
            couponData.value = product.price
            setSession('discountCoupon', couponData)
        }
        // Comentado para evitar erro com produtos de valor zero, min 1, max 1, que não são sabores (ex: HOTMIX Japesca)
        if (isCouponProduct /*&& isFlavor()*/) {
            const discountCoupon = getSession('discountCoupon', {})
            discountCoupon.value = total
            setSession('discountCoupon', discountCoupon)
        }
        if (isEditing) {
            const index_item = items.findIndex((i) => (i.id === item.id))
            items[index_item] = itemToCreate
        } else {
            items.push(itemToCreate)
        }
        trackEventPixel('AddToCart', {
            content_name: itemToCreate.product,
            value: itemToCreate.price,
            currency: 'BRL'
        })
        trackEventAnalytics('add_to_cart', {
            currency: 'BRL',
            value: itemToCreate.price,
            items: formatItemsAnalytics(items)
        })
        setLocal(`maximumQuantity=${product.sku}`, (dataMaximumQuantity.maximumQuantity - productQuantity))
        setLocal('items', items)
        setLocal('addedSomethingToTheItemBag', 'yes')
        if (linkRedirection) navigate('/', {replace: true})
        else navigate(-1)
    }

    const sortItemsByStep = (items) => {
        return items.sort((a, b) => {
            if (a.stepIndex < b.stepIndex) return -1
            if (a.stepIndex > b.stepIndex) return 1
            return a.stepIndex - b.stepIndex
        })
    }

    const checkMaximumQuantity = () => {
        const maximumQuantityLocal = getLocal(`maximumQuantity=${product.sku}`)
        const maximumQuantity = (!isEmpty(maximumQuantityLocal)) ? maximumQuantityLocal : checkUndefined(product.qtdeMax, 100)
        if (productQuantity > maximumQuantity) {
            return {
                response: false,
                message: textsItemBag.limitPerOrder,
                maximumQuantity: maximumQuantity
            }
        }
        return {
            response: true,
            maximumQuantity: maximumQuantity
        }
    }

    const addItemsOptions = (additional, options) => {
        const items = []
        const array = checkUndefined(Object.values(additional), [])
        array.forEach(([...a]) => items.push(...a))
        items.forEach(item => {
            const index = options.findIndex((o) => (o.sku === item.sku && o.stepIndex === item.stepIndex))
            if (index === -1) {
                options.push(item)
            } else {
                let p = items.filter((i) => (i.sku === item.sku))
                options[index].amount = p.length
            }
        })
    }

    const checkMandatory = (options) => {
        const steps = product.variations.filter(v => (v.minSelection >= 1 && (v.visibility.includes('DIGITALMENU'))))
        for (const s of steps) {
            const array = options.filter(o => (o.stepIndex === s.stepIndex))
            const selection = array.reduce((total, item) => total + item.amount, 0)
            if (selection < s.minSelection) {
                return {response: false, message: `${textsItemsBag.mandatoryStep} "${s.variation}"`, step: s.stepIndex}
            }
        }
        return {response: true}
    }

    useEffect(() => {
        window.scroll(0, 0)
        checkEditItem()
        checkViewObservations()
        trackEventPixel('ViewContent', {
            content_name: product?.product,
            content_category: 'Compras'
        })
        trackPageView()
    }, [])

    const checkEditItem = () => {
        if (isEditing) {
            setProductQuantity(itemEditing.amount)
            setQuantityFractioned(itemEditing.amount)
            setItem({...itemEditing})
            setEdit(isEditing)
        }
    }

    const checkViewObservations = () => setVisibleObs(!isEmpty(product.visibleObs) ? product.visibleObs : true)

    useEffect(() => checkValuesStep(), [additional, optional])

    const checkValuesStep = () => {
        let valueAdditional = 0
        const itemsAdditional = []
        const arrayAdditional = checkUndefined(Object.values(additional), [])
        arrayAdditional.forEach(([...items]) => itemsAdditional.push(...items))
        itemsAdditional.forEach(a => {
            valueAdditional += (a.sku.includes('S') ? a.valuePercentage : a.priceProduct)
        })
        let valueOptional = 0
        const itemsOptional = []
        const arrayOptional = checkUndefined(Object.values(optional), [])
        arrayOptional.forEach(([...items]) => itemsOptional.push(...items))
        itemsOptional.forEach(a => {
            valueOptional += (a.sku.includes('S') ? a.valuePercentage : a.priceProduct)
        })
        const priceMap = new Map()
        itemsOptional.forEach(item => {
            priceMap.set(item.stepIndex, item)
        })
        itemsAdditional.forEach(item => {
            priceMap.set(item.stepIndex, item)
        })
        const totalPriceStep = Array.from(priceMap.values()).reduce((sum, item) => {
            return sum + item?.priceStep || 0
        }, 0)
        const arrayFlavors = itemsAdditional.filter(item => item.sku.includes('S'))
        setFlavorItems(arrayFlavors)
        setAdditionalTotal(valueAdditional + valueOptional + totalPriceStep)
    }

    useEffect(() => checkValues(), [productQuantity, additionalTotal])

    const checkValues = () => {
        const baseValue = (product.typeproduct === 'C') ? 0 : product.price
        const total = ((baseValue + additionalTotal) * productQuantity)
        setTotal(total)
        setAddItem(!isAddItem)
    }

    useEffect(() => {
        checkVariations()
    }, [])

    useEffect(() => {
        checkModeFlavor()
    }, [flavorItems])

    const checkVariations = () => {
        const variations = []
        product.variations.forEach(v => {
            if ((v.minSelection === 1) && (v.maxSelection === 1) && (v.options.length === 1)) {
                addOption(v.options[0], v.step, v?.stepIndex, v.price)
            } else {
                const categorys = []
                v.options.map(item => {
                    if (!!item.category) {
                        categorys.push('Todos')
                        categorys.push(item.category)
                    }
                })
                v.filterFlavor = [...new Set(categorys)]
                if (!v?.visibility) v.visibility = ["DIGITALMENU"]
                variations.push(v)
            }
        })
        setVariations(variations)
    }

    const checkModeFlavor = () => {
        try {
            const variations = checkUndefined(product.variations, [])
            if ((flavorItems.length > 0) && (variations[0].maxSelection > 1) && (variations[0].options[0].sku.includes('S'))) {
                const tourFilter = getLocal('tourFilter', '')
                if (!tourFilter) setTimeout(() => setTour({open: true, step: 0}), 100)
                setLocal('tourFilter', 'ok')
                setModeFlavor(true)
                return
            }
        } catch (e) {
            log(e.message, 'log')
        }
        return setModeFlavor(false)
    }

    const isFlavor = () => {
        try {
            const variations = checkUndefined(product.variations, [])
            return variations[0].options[0].sku.includes('S')
        } catch (e) {
            log(e.message, 'log')
        }
        return false
    }

    const addOption = (option, step, stepIndex = 0, priceStep = 0) => {
        option.valuePercentage = option.price
        option.priceProduct = option.price
        option.amount = 1
        option.step = step
        option.stepIndex = stepIndex
        option.priceStep = (priceStep || 0)
        optional[stepIndex] = [option]
        setOptional({...optional})
    }

    window.onscroll = () => {
        try {
            const currentScrollPos = window.pageYOffset
            if (prevScrollpos > currentScrollPos) {
                document.getElementById('app-bar').style.top = '0'
                document.getElementById('app-bar').style.position = 'fixed'
                document.getElementById('image-product-bag').style.marginTop = '50px'
                document.getElementById('app-bar').classList.add('visible')
            } else {
                document.getElementById('app-bar').style.top = '-50px'
                document.getElementById('app-bar').style.position = 'static'
                document.getElementById('image-product-bag').style.marginTop = '0'
            }
            setPrevScrollpos(currentScrollPos)
        } catch (e) {

        }
    }

    const handlePressKeyboard = event => {
        if (event.key === 'Escape') {
            navigate(-1)
        } else if (event.key === 'F8') {
            handleClickAdd()
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handlePressKeyboard, false)
        return () => document.removeEventListener('keydown', handlePressKeyboard, false)
    }, [])

    const styles = getLocal('colors')

    colors(document)

    return <ThemeProvider theme={themeMui(styles)}>
        <ItemBagContext.Provider value={{
            total,
            setTotal,
            observations,
            setObservations,
            setObservationItem,
            optional,
            setOptional,
            additional,
            setAdditional,
            item,
            isEdit,
            modeFlavor,
            flavorItems,
            itemDelete,
            setItemDelete,
            setTour,
            setQuantityFractioned,
            quantityFractioned,
            productQuantity,
            setProductQuantity,
            isAddItem,
            setAddItem,
            setSnackbar
        }}>
            <motion.div
                className={'item-bag'}
                initial={{x: 400}}
                animate={{x: 0}}
                transition={{duration: 0.3}}>
                <Header title={product.product} isPromo={linkRedirection} buttonBack={true} buttonSearch={true}
                        onChange={handleSearch}/>
                <div className={'container-item-bag'}>
                    <ImageProduct image={product.image}/>
                    <InformationProduct
                        product={product}
                        isCouponProduct={isCouponProduct}
                        onMessage={handleMessage}
                        onClick={handleClickInfo}/>
                    <Variations
                        variations={variations}
                        onClick={handleClickVariation}
                        onNext={handleNextStep}
                    />
                    <InputObservation visible={isVisibleObs}/>
                    <FloatingButton onClick={handleClickFloationgButton}/>
                    <AddBagBuyButton canOrder={canOrder} onClick={handleClickAdd}/>
                    <Tour
                        isOpen={tour.open}
                        steps={steps_tour}
                        goToStep={tour.step}
                        onRequestClose={() => {
                        }}
                        disableFocusLock={true}
                        showCloseButton={false}
                        showNumber={false}
                        showButtons={false}
                        showNavigation={false}
                    />
                </div>
                <>
                    <DialogQuantity
                        open={dialogQuantity.open}
                        product={product}
                        onClose={handleCloseDialogQuantity}
                    />
                    <DialogFlavor
                        open={dialogFlavor.open}
                        flavorItems={flavorItems}
                        onClick={handleClickDialogFlavor}
                        onClose={handleCloseDialogFlavor}
                    />
                    <Snackbar
                        open={snackbar.open}
                        autoHideDuration={1600}
                        onClose={handleCloseSnackbar}
                        message={snackbar.message}/>
                </>
            </motion.div>
        </ItemBagContext.Provider>
    </ThemeProvider>
}

export default ItemBag
